import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { AnchorLink } from 'components/anchorLink';
import { Button } from 'components/button';
import { Icon, IconsEnum } from 'components/Icons';
import { CompetitorIcon } from 'components/scommesseTable/scommesseTableCompetitors';
import { getCambioMatchList } from 'features/sport/actions';
import { useInfoTemplateAvvenimento, useIsLivePage } from 'features/sport/hooks';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useAppDispatch } from 'lib/centralStore';
import { SportsAvvListForNavDto, SportsCacheTemplateAvvenimentoDto } from 'types/swagger';
import { isTruthy, toSportUrlCase } from 'utility/functions';
import styles from './SportChangeMatchList.module.scss';
import { useBlockScroll } from 'hooks/useBlockScroll';
import useWindowSize from 'hooks/useWindowSize';

export type SportChangeMatchListProps = {};

export const SportChangeMatchList = () => {
  const dispatch = useAppDispatch();
  const isLive = useIsLivePage();
  const { templateAvvenimento } = useInfoTemplateAvvenimento<SportsCacheTemplateAvvenimentoDto>();
  const { idDisciplina, idManifestazione, key } = templateAvvenimento ?? {};
  const [isOpenDropdown, setIsOpenDropdown] = useState<boolean>(false);
  const [cambioMatchList, setCambioMatchList] = useState<SportsAvvListForNavDto>();
  const labelCambiaMatch = useGetLabelByKey('cambia-match');
  const { isMobile } = useWindowSize();

  useBlockScroll(isMobile && isOpenDropdown);

  useEffect(() => {
    const fetch = async () => {
      const result = await dispatch(getCambioMatchList({ isLive, idManifestazione, idDisciplina, key })).unwrap();
      setCambioMatchList(result.data);
    };
    fetch();
  }, [dispatch, idDisciplina, idManifestazione, isLive, key]);

  return (
    isTruthy(cambioMatchList?.manifestazioneList?.length) && (
      <>
        <button
          className={classNames(styles.buttonChangeMatch, { [styles.isOpen]: isOpenDropdown, [styles.isLive]: isLive })}
          onClick={() => setIsOpenDropdown(!isOpenDropdown)}
        >
          <span className={styles.changeMatchTextButton}>{labelCambiaMatch}</span>
          <span className={classNames(styles.chewron, { [styles.arrowUp]: isOpenDropdown })}>
            <Icon iconId={IconsEnum.CHEVRON_DOWN} color="var(--color-on-bg-primary)" />
          </span>
        </button>

        <div
          className={classNames(styles.containerList, {
            [styles.show]: isOpenDropdown,
            [styles.hide]: !isOpenDropdown,
          })}
        >
          <div key={cambioMatchList?.disciplinaTrKey} className={classNames(styles.disciplinaBox, styles.item)}>
            <span className={styles.disciplinaText}>
              {isLive ? cambioMatchList?.disciplina : cambioMatchList?.manifestazioneList?.[0]?.manifestazione}
            </span>
            <Button size="small" className={styles.closeButton} onClick={() => setIsOpenDropdown(false)}>
              <Icon iconId={IconsEnum.CLOSE} aria-hidden="true" className={styles.closeIcon} />
            </Button>
          </div>
          <div className={styles.scrollWrapper}>
            <ul>
              {cambioMatchList?.manifestazioneList?.map((manifestazione) => (
                <li key={manifestazione.manifestazioneTrKey} className={styles.item}>
                  <p className={classNames(styles.gruppo, { [styles.hidden]: !isLive })}>
                    {manifestazione.manifestazione}
                  </p>
                  <ul className={styles.avvenimentiList}>
                    {(manifestazione.avvenimentoList ?? []).map((avvenimento) => (
                      <li key={avvenimento.descrizione}>
                        <AnchorLink className={styles.match} href={toSportUrlCase(`/${avvenimento.slug}`)}>
                          {avvenimento.firstCompetitor && avvenimento.secondCompetitor ? (
                            <>
                              <p className={classNames(styles.competitor, styles.firstCompetitor)}>
                                {avvenimento.firstCompetitor?.descrizione}
                              </p>
                              {avvenimento.firstCompetitor?.iconSrc ? (
                                <div
                                  className={classNames(styles.imageContainer, styles.firstCompetitorIcon)}
                                  title={avvenimento.descrizioneTrKey}
                                  suppressHydrationWarning
                                >
                                  <CompetitorIcon
                                    className={styles.image}
                                    iconSrc={avvenimento.firstCompetitor.iconSrc}
                                  />
                                </div>
                              ) : (
                                <span className={styles.emptyIcon} />
                              )}
                              {avvenimento.live ? (
                                <p
                                  className={styles.score}
                                >{`${avvenimento.live?.score?.firstCompetitor} - ${avvenimento.live?.score?.secondCompetitor}`}</p>
                              ) : (
                                <span className={classNames(styles.noShowScore, { [styles.accent]: isLive })}>-</span>
                              )}
                              {avvenimento.secondCompetitor?.iconSrc ? (
                                <div
                                  className={classNames(styles.imageContainer, styles.secondCompetitorIcon)}
                                  title={avvenimento.descrizioneTrKey}
                                  suppressHydrationWarning
                                >
                                  <CompetitorIcon
                                    className={styles.image}
                                    iconSrc={avvenimento.secondCompetitor.iconSrc}
                                  />
                                </div>
                              ) : (
                                <span className={styles.emptyIcon} />
                              )}
                              <p className={classNames(styles.competitor, styles.secondCompetitor)}>
                                {avvenimento.secondCompetitor?.descrizione}
                              </p>
                            </>
                          ) : (
                            <p className={classNames(styles.descrizione)}>{avvenimento.descrizione}</p>
                          )}
                        </AnchorLink>
                      </li>
                    ))}
                  </ul>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </>
    )
  );
};
